"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatSteps = void 0;
var TRANSLATION = 'Translation';
var formatSteps = function (data) {
    var input = __assign(__assign({}, data), { steps: [] });
    var stepsRegex = /(\w+)_(\d+)/;
    var inputKeys = Object.keys(input).filter(function (key) { return stepsRegex.test(key); });
    inputKeys.forEach(function (key) {
        var property = key.match(stepsRegex);
        if (!property) {
            return;
        }
        var isPropertyTranslation = key.split('_')[1].includes(TRANSLATION);
        var propertyKey = property[1];
        if (isPropertyTranslation && !propertyKey.includes(TRANSLATION)) {
            propertyKey += TRANSLATION;
        }
        var propertyIndex = +property[2] - 1;
        var steps = input.steps;
        if (!steps[propertyIndex]) {
            steps[propertyIndex] = {};
        }
        steps[propertyIndex][propertyKey] = input[key];
        delete input[key];
    });
    return input;
};
exports.formatSteps = formatSteps;
